<template>
<article class="resports-wrapper">
  <notification />
  <section class="reports-section">
    <header-simple :title="title" />
    <loader-spinner class="report-loader" v-show="exporting"/>
    <div v-show="!exporting" class="report-container">
      <mds-form>
        <div class="report-type-container">
          <div class="report-instruction-text">
            To see all the available reports in Connect, click on dropdown menu below.
          </div>
          <div class="report-instruction-text">To generate desired report, select a report from dropdown menu.</div>
          <mds-select
            label="Select a Report:"
            :options="reportTypeList"
            :disabled="reportTypeList.length === 0"
            placeholder="Select a Report"
            class="report-dropdown"
            @change="onSelectReport"
          ></mds-select>
        </div>
        <div v-if="selectedReportType === 'consultant_intranet'" class="report-selection-content">
          <div class="report-instruction-text">
            Generate Monthly Screen Reports- FO, FV, CT, SA
          </div>
          <div class="report-content">
            <mds-select
              label="Select Security Type:"
              :options="securityTypeList"
              placeholder="Select Security type"
              class="report-dropdown report-flex-item"
              @change="onSelectSecurityType"
            ></mds-select>
            <mds-button
              class="generate-report-button report-flex-item"
              variation="primary"
              :disabled="!selectedSecurityType"
              @click.prevent="generateConsultantIntranetReport"
            >
              Generate Reports
          </mds-button>
          </div>
        </div>
        <div v-if="selectedReportType === 'ubs_none_fund_approvals'" class="report-selection-content">
          <div class="report-content">
            <mds-button
                class="generate-multistatus-report report-flex-item"
                variation="primary"
                @click.prevent="downloadMultistatusReport"
              >
                Download Report
            </mds-button>
          </div>
        </div>
      </mds-form>
    </div>
  </section>
</article>
</template>

<script>
import HeaderSimple from '@/components/atoms/HeaderSimple';
import MdsForm from '@mds/form';
import MdsSelect from '@mds/select';
import Notification from '@/components/atoms/Notification';
import LoaderSpinner from '@/components/atoms/LoadingSpinner';
import FileSaver from 'file-saver';
import b64toBlob from 'b64-to-blob';
import { mapState } from 'vuex';
import { get } from 'lodash';
import { generateReportConsultantIntranet, generateMultistatusFundReport } from '../services/Reports';

const REPORT_TYPES = [
  {
    value: 'consultant_intranet',
    text: 'Consultant Intranet',
  },
];

const UBS_REPORT = {
  value: 'ubs_none_fund_approvals',
  text: ' UBS None Fund Approvals and LCSC',
};

const SECURITY_TYPES = [
  {
    value: 'FO',
    text: 'FO',
  },
  {
    value: 'FV',
    text: 'FV',
  },
  {
    value: 'CT',
    text: 'CT',
  },
  {
    value: 'SA',
    text: 'SA',
  },
];

export default {

  name: 'Reports',
  components: {
    HeaderSimple,
    MdsForm,
    MdsSelect,
    Notification,
    LoaderSpinner,
  },
  data() {
    return {
      title: 'Reports',
      securityTypeList: SECURITY_TYPES,
      selectedReportType: '',
      selectedSecurityType: '',
      exporting: false,
    };
  },
  computed: {
    ...mapState({
      userRole: (state) => state.user.userRole,
      policies: (state) => state.user.policies,
      selectedFiduciary: (state) => state.user.fiduciary,
    }),
    reportTypeList() {
      const list = REPORT_TYPES.filter((item) => {
        return this.reportPolicies[item.value];
      });
      if (this.selectedFiduciary.code === 'UBS') {
        list.push(UBS_REPORT);
      }
      return list;
    },
    reportPolicies() {
      return get(this.policies, 'Reports')['report-type'];
    },
  },
  methods: {
    onSelectReport(event) {
      this.selectedReportType = event.target.value;
    },
    onSelectSecurityType(event) {
      this.selectedSecurityType = event.target.value;
    },
    handleErrorOnReport(error) {
      this.exporting = false;
      const httpStatus = (error?.response?.status) ? (error?.response.status) : error?.status;
      if (httpStatus === 401) {
        this.$router.push('/Login');
      }
      if (!httpStatus) {
        this.$store.dispatch('openNotification', {
          message: 'Error while fetching report',
          notificationType: 'error',
        });
      }
    },
    processReportResponse(response, notificationMessage) {
      const { data } = response;
      const blob = b64toBlob(data.file, data.type);
      FileSaver.saveAs(blob, data.filename);
      this.exporting = false;
      this.$store.dispatch('openNotification', {
        message: notificationMessage,
      });
    },
    generateConsultantIntranetReport() {
      this.exporting = true;
      generateReportConsultantIntranet(this.selectedSecurityType).then((response) => {
        const notificationMessage = 'Monthly Report Generated Successfully!';
        this.processReportResponse(response, notificationMessage);
      }).catch((error) => {
        this.handleErrorOnReport(error);
      });
    },
    downloadMultistatusReport() {
      this.exporting = true;
      generateMultistatusFundReport(this.selectedFiduciary.id).then((response) => {
        if (response.status.success) {
          this.exporting = false;
          const { url } = response.data;
          this.downloadReportFromLink(url);
          this.$store.dispatch('openNotification', {
            message: 'Multistatus Report Generated Successfully!',
          });
        }
      }).catch((error) => {
        this.handleErrorOnReport(error);
      });
    },
    downloadReportFromLink(url) {
      const anchor = document.createElement('a');
      anchor.href = url;
      anchor.setAttribute('download', 'download');
      document.body.appendChild(anchor);
      anchor.click();
      anchor.parentNode.removeChild(anchor);
    },
  },
};
</script>
<style lang="scss">
.reports-section {
  display: flex;
  flex-direction: column;
}
.report-instruction-text {
  @include mds-level-6-heading();
}
.report-loader {
  margin: auto;
}
.report-container {
  padding: $mds-space-4-x;
}
.report-dropdown {
  width: 300px;
  margin-top: 40px;
}
.report-selection-content {
  margin-top: 60px;
}
.report-content {
  display: flex;
  align-items: flex-end;

  .generate-report-button {
    margin: 0 0 20px 15px;
  }
}
</style>
